import { Alert } from '@apollo/orbit';
import React from 'react';

import { assertUnreachableOrReturnDefault } from 'src/lib/assertUnreachable';
import {
  BuildPipelineTrack,
  BuildPipelineTrackBadge,
} from 'src/lib/graphqlTypes/types';

export const BuildPipelineTrackBanner = ({
  status,
  className,
  track,
}: {
  status: BuildPipelineTrackBadge;
  className?: string;
  track?: BuildPipelineTrack;
}) => {
  if (track === BuildPipelineTrack.FED_NEXT) {
    return (
      <Alert status="warning" className={className}>
        <span className="font-semibold">
          This Federation version is in preview.
        </span>{' '}
        Until it reaches general availability, use of this version in any
        production variant should be considered carefully.
      </Alert>
    );
  }

  switch (status) {
    case BuildPipelineTrackBadge.DEPRECATED:
      return (
        <Alert status="warning" className={className}>
          <span className="font-semibold">
            This Federation version is deprecated.
          </span>{' '}
          You should upgrade to a later version as soon as possible.
        </Alert>
      );
    case BuildPipelineTrackBadge.EXPERIMENTAL:
      return (
        <Alert status="warning" className={className}>
          <span className="font-semibold">
            This Federation version is experimental.
          </span>{' '}
          Until it reaches general availability, do not use this version in any
          production variant.
        </Alert>
      );
    case BuildPipelineTrackBadge.UNSUPPORTED:
      return (
        <Alert status="warning" className={className}>
          <span className="font-semibold">
            This Federation version is no longer supported.
          </span>{' '}
          You should upgrade to a supported version as soon as possible.
        </Alert>
      );
    case BuildPipelineTrackBadge.LATEST:
      return <></>;
    default:
      return assertUnreachableOrReturnDefault(
        status,
        <Alert status="info" className={className}>
          This federation version's status is unknown
        </Alert>,
      );
  }
};
